import { render, staticRenderFns } from "./LanguageItem.vue?vue&type=template&id=3c65ab46&scoped=true"
import script from "./LanguageItem.vue?vue&type=script&lang=js"
export * from "./LanguageItem.vue?vue&type=script&lang=js"
import style0 from "./LanguageItem.vue?vue&type=style&index=0&id=3c65ab46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c65ab46",
  null
  
)

export default component.exports